module.exports = __webpack_public_path__ + "media/images/pic/saska/hero_contact_saska-ad345a6937045573567cecdeda924ec8.png";